<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ copyrightText }}</div>
        <div class="col-sm-6"><div class="text-sm-end d-none d-sm-block">{{ creditText }}</div></div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data: () => ({ configuration: {} }),
  computed: {
    replacements() { return { year: new Date().getFullYear(), appName: this.configuration.app_name || 'AAI LES', companyName: this.configuration.company_name || 'Company' }; },
    copyrightText() { return this.replace(this.configuration.footer_copyright_text || '{year} © {appName}.'); },
    creditText() { return this.replace(this.configuration.footer_credit_text || 'Design & Develop by {companyName}'); },
  },
  mounted() { this.refresh(); window.addEventListener('app:system-configuration-updated', this.onUpdate); },
  beforeUnmount() { window.removeEventListener('app:system-configuration-updated', this.onUpdate); },
  methods: {
    refresh() { try { this.configuration = JSON.parse(localStorage.getItem('systemConfiguration') || '{}'); } catch { this.configuration = {}; } },
    onUpdate(event) { this.configuration = event.detail || {}; },
    replace(value) { return value.replace(/\{(year|appName|companyName)\}/g, (_, key) => this.replacements[key]); },
  },
};
</script>
